module.exports = __webpack_public_path__ + "img/PM_A02_front_cross_en.7eb0e68a.png";